/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconContrast2Off = createReactComponent("contrast-2-off", "IconContrast2Off", [
  [
    "path",
    {
      d: "M4 18h2a6 6 0 0 0 6 -6m.878 -3.126a6 6 0 0 1 5.122 -2.874h2",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405",
      key: "svg-1"
    }
  ],
  ["path", { d: "M3 3l18 18", key: "svg-2" }]
]);

export { IconContrast2Off as default };
//# sourceMappingURL=IconContrast2Off.js.map
